<template>
  <div>
    <div class="section text-black pt-3 pb-0">
      <i class="bi bi-arrow-left ml-3 goBackArrow" v-on:click="goBack()"></i>
      <div class="container"></div>

      <div class="mt-4" v-if="allLoaded">
        <div class="row text-center mx-0">
          <div class="col-lg-5 col-md-12 px-3 px-lg-5" v-if="allLoaded">
            <div style="height: 100%; text-align: left">
              <h5 class="postcardpercorsi__title orange">
                <b
                  >Dettagli itinerario creato (codice:
                  <!--  0gJoQytte4ZxfMkvnDE0) -->
                  <template v-if="itineraryCode !== null"
                    >{{ itineraryCode }}
                  </template>
                  <template v-else>Codice non conosciuto</template>
                  )
                  </b
                >
              </h5>

              <div class="mb-3">
                Il tempo totale include anche gli spostamenti da un luogo
                all'altro all'interno della stessa area, escludendo il tempo per
                trovare parcheggio e per andare dal punto di partenza al primo
                punto dell'itinerario.
              </div>

              <div v-if="$store.state.sottoitinerari.length > 1">
                Il tempo totale include anche gli spostamenti da un'area
                all'altra.

                <div
                  class="mt-3"
                  v-for="(time, index) in travellingTime"
                  :key="index"
                >
                  {{ time }} <i class="bi bi-clock mr-2"></i>
                </div>
              </div>
              <div
                class="mt-3"
                v-if="Object.keys(totalTimeObject).length === 0 || timeIsZero"
              >
                <h6><i class="bi bi-clock mr-2"></i> Durata non disponibile</h6>
              </div>
              <div v-else class="mt-3">
                <h6
                  class="card-title"
                  v-if="
                    parseInt(totalTimeObject.hours) === 1 &&
                    parseInt(totalTimeObject.minutes) === 0
                  "
                >
                  <i class="bi bi-clock mr-2"></i>
                  {{ totalTimeObject.hours }} ora
                </h6>
                <h6
                  class="card-title"
                  v-else-if="parseInt(totalTimeObject.hours) === 1"
                >
                  <i class="bi bi-clock mr-2"></i>
                  {{ parseInt(totalTimeObject.hours) }} ora e
                  {{ parseInt(totalTimeObject.minutes) }} minuti
                </h6>
                <h6
                  class="card-title"
                  v-else-if="
                    parseInt(totalTimeObject.hours) > 0 &&
                    parseInt(totalTimeObject.minutes) === 0
                  "
                >
                  <i class="bi bi-clock mr-2"></i>
                  {{ parseInt(totalTimeObject.hours) }} ore
                </h6>
                <h6
                  class="card-title"
                  v-else-if="parseInt(totalTimeObject.hours) > 0"
                >
                  <i class="bi bi-clock mr-2"></i>
                  {{ parseInt(totalTimeObject.hours) }} ore e
                  {{ parseInt(totalTimeObject.minutes) }} minuti
                </h6>
                <h6 class="card-title" v-else>
                  <i class="bi bi-clock mr-2"></i>
                  {{ parseInt(totalTimeObject.minutes) }} minuti
                </h6>
              </div>
              <!-- <div class="mt-3">
                Da svolgere preferibilmente:
                <b>{{ itinerario.preferredPartOfDay.toUpperCase() }}</b>
              </div> -->
              <div v-if="itineraryCode !== null" class="row mt-3">
                <div class="col-12">
                  <Button
                    type="primary"
                    size="small"
                    v-on:click="copyItineraryCode()"
                    class="button_font"
                    >Copia codice itinerario
                  </Button>
                </div>
              </div>

              <div class="row mt-3" >
                <div class="col-12">
                  <!--v-if="itineraryCode !== null"-->
                  <Button
                    type="primary"
                    size="small"
                    v-on:click="askQuestion()"
                    class="button_font"
                    >Prenota Itinerario
                  </Button>
                </div>
              </div>

              <hr />

              <div class="aree__tagbox mb-4">
                <button
                  :class="
                    selectedArea === index
                      ? 'tag__item__selected'
                      : 'tag__item__unselected'
                  "
                  v-for="(sottoitinerario, index) in $store.state
                    .sottoitinerari"
                  :key="index"
                  v-on:click="selectItinerario(index)"
                >
                  {{ sottoitinerario.name.substring(11) }}
                </button>
              </div>
              <div class="col-lg-8 col-sm-12 pr-3 d-block d-lg-none mb-4">
                <div class="mb-4">
                  <h6>
                    Tempo sottoitinerario -
                    {{
                      $store.state.sottoitinerari[selectedArea].name.substring(
                        11
                      )
                    }}
                  </h6>
                  <h6
                    class="card-title"
                    v-if="
                      parseInt(totalTimeSelectedArea.hours) === 1 &&
                      parseInt(totalTimeSelectedArea.minutes) === 0
                    "
                  >
                    <i class="bi bi-clock mr-2"></i>
                    {{ totalTimeSelectedArea.hours }} ora
                  </h6>
                  <h6
                    class="card-title"
                    v-else-if="parseInt(totalTimeSelectedArea.hours) === 1"
                  >
                    <i class="bi bi-clock mr-2"></i>
                    {{ parseInt(totalTimeSelectedArea.hours) }} ora e
                    {{ parseInt(totalTimeSelectedArea.minutes) }} minuti
                  </h6>
                  <h6
                    class="card-title"
                    v-else-if="
                      parseInt(totalTimeSelectedArea.hours) > 0 &&
                      parseInt(totalTimeSelectedArea.minutes) === 0
                    "
                  >
                    <i class="bi bi-clock mr-2"></i>
                    {{ parseInt(totalTimeSelectedArea.hours) }} ore
                  </h6>
                  <h6
                    class="card-title"
                    v-else-if="parseInt(totalTimeSelectedArea.hours) > 0"
                  >
                    <i class="bi bi-clock mr-2"></i>
                    {{ parseInt(totalTimeSelectedArea.hours) }} ore e
                    {{ parseInt(totalTimeSelectedArea.minutes) }} minuti
                  </h6>
                  <h6 class="card-title" v-else>
                    <i class="bi bi-clock mr-2"></i>
                    {{ parseInt(totalTimeSelectedArea.minutes) }} minuti
                  </h6>
                </div>
                <div class="row">
                  <div class="col-12 d-flex px-0">
                    <div
                      class="mb-2 mx-lg-auto mt-0 aree__tagbox"
                      :class="{
                        'w-100': !isLarge,
                      }"
                    >
                      <button
                        :class="
                          selectedTab === 'ElencoAttività'
                            ? 'tag__item__selected'
                            : 'tag__item__unselected'
                        "
                        v-on:click="selectedTab = 'ElencoAttività'"
                      >
                        Elenco delle attività
                      </button>
                      <button
                        :class="
                          selectedTab === 'Mappa'
                            ? 'tag__item__selected'
                            : 'tag__item__unselected'
                        "
                        v-on:click="selectedTab = 'Mappa'"
                      >
                        Mappa
                      </button>
                    </div>
                  </div>

                  <div
                    class="col-12 px-0"
                    v-if="selectedTab === 'ElencoAttività'"
                  >
                    <div v-if="!showDetails" class="mb-4">
                      <!--QUA METTERE COMPONENT SMALL-->
                      <ElencoPoiSmTesi
                        :itinerario="itinerario"
                        :timeFromParkingToFirstPOI="timeFromParkingToFirstPOI"
                        v-on:selectMarkerOnMap="selectMarkerOnMap"
                      ></ElencoPoiSmTesi>
                    </div>
                    <div v-else>
                      <div class="row mt-2">
                        <div class="col-12">
                          <i
                            class="bi bi-arrow-left ml-3 mb-5"
                            style="
                              font-size: 1.5rem;
                              color: black;
                              cursor: pointer;
                            "
                            v-on:click="showItinerary()"
                          >
                            Visualizza elenco attività</i
                          >
                          <div class="mt-4">
                            <div
                              class="row my-3"
                              v-if="drinkingWaterPoints.length > 0"
                            >
                              <div class="col-12">
                                Visualizza fontanelle nei dintorni sulla mappa
                                <n-switch
                                  class="mx-3 mt-2"
                                  v-model="showDrinkingWater"
                                ></n-switch>
                              </div>
                            </div>
                            <esperimento
                              class="align-top text-center"
                              :item="activitySelectedForInfo"
                              :hasCorrectAmbito="true"
                              v-if="activitySelectedForInfo !== null"
                            ></esperimento>
                            <visita
                              class="align-top text-center"
                              :item="activityVisitPOISelectedForInfo"
                              v-if="activityVisitPOISelectedForInfo !== null"
                            ></visita>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 px-0" v-if="selectedTab === 'Mappa'">
                    <MappaSintesiItinerario
                      :markers="markers"
                      :drinkingWaterPoints="drinkingWaterPoints"
                      :showDrinkingWater="showDrinkingWater"
                      :desktop="false"
                      :selectedLunchPoint="selectedLunchPoint"
                    />
                  </div>
                </div>
              </div>
              <div class="d-none d-lg-block">
                <div class="mb-4">
                  <h6>
                    Tempo sottoitinerario -
                    {{
                      $store.state.sottoitinerari[selectedArea].name.substring(
                        11
                      )
                    }}
                  </h6>
                  <h6
                    class="card-title"
                    v-if="
                      parseInt(totalTimeSelectedArea.hours) === 1 &&
                      parseInt(totalTimeSelectedArea.minutes) === 0
                    "
                  >
                    <i class="bi bi-clock mr-2"></i>
                    {{ totalTimeSelectedArea.hours }} ora
                  </h6>
                  <h6
                    class="card-title"
                    v-else-if="parseInt(totalTimeSelectedArea.hours) === 1"
                  >
                    <i class="bi bi-clock mr-2"></i>
                    {{ parseInt(totalTimeSelectedArea.hours) }} ora e
                    {{ parseInt(totalTimeSelectedArea.minutes) }} minuti
                  </h6>
                  <h6
                    class="card-title"
                    v-else-if="
                      parseInt(totalTimeSelectedArea.hours) > 0 &&
                      parseInt(totalTimeSelectedArea.minutes) === 0
                    "
                  >
                    <i class="bi bi-clock mr-2"></i>
                    {{ parseInt(totalTimeSelectedArea.hours) }} ore
                  </h6>
                  <h6
                    class="card-title"
                    v-else-if="parseInt(totalTimeSelectedArea.hours) > 0"
                  >
                    <i class="bi bi-clock mr-2"></i>
                    {{ parseInt(totalTimeSelectedArea.hours) }} ore e
                    {{ parseInt(totalTimeSelectedArea.minutes) }} minuti
                  </h6>
                  <h6 class="card-title" v-else>
                    <i class="bi bi-clock mr-2"></i>
                    {{ parseInt(totalTimeSelectedArea.minutes) }} minuti
                  </h6>
                </div>

                <div v-if="!showDetails" class="mb-4 row">
                  <div class="col-12">
                    <div class="d-sm-block d-md-none">
                      <ElencoPoiSmTesi
                        :itinerario="itinerario"
                        :timeFromParkingToFirstPOI="timeFromParkingToFirstPOI"
                        v-on:selectMarkerOnMap="selectMarkerOnMap"
                      ></ElencoPoiSmTesi>
                    </div>
                    <div class="d-sm-none d-md-block col-12">
                      <ElencoPoiMdLgTesi
                        :itinerario="itinerario"
                        :timeFromParkingToFirstPOI="timeFromParkingToFirstPOI"
                        v-on:selectMarkerOnMap="selectMarkerOnMap"
                        v-if="isLarge"
                        :screenSize="'medium'"
                      ></ElencoPoiMdLgTesi>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="row mt-2">
                    <div class="col-12">
                      <i
                        class="bi bi-arrow-left ml-3"
                        style="font-size: 1.5rem; color: black; cursor: pointer"
                        v-on:click="goBackAndResetMarkersIcon()"
                      >
                        Visualizza elenco attività</i
                      >

                      <div
                        class="row my-3"
                        v-if="drinkingWaterPoints.length > 0"
                      >
                        <div class="col-12">
                          Visualizza fontanelle nei dintorni sulla mappa
                          <n-switch
                            class="mx-3 mt-2"
                            v-model="showDrinkingWater"
                          ></n-switch>
                        </div>
                      </div>

                      <div class="mt-4">
                        <esperimento
                          class="align-top text-center"
                          :item="activitySelectedForInfo"
                          :hasCorrectAmbito="true"
                          v-if="activitySelectedForInfo !== null"
                        ></esperimento>
                        <visita
                          class="align-top text-center"
                          :item="activityVisitPOISelectedForInfo"
                          v-if="activityVisitPOISelectedForInfo !== null"
                        ></visita>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-7 col-md-0 col-sm-12 pr-3 d-none d-lg-block">
            <div class="row px-4">
              <div class="col-12">
                <MappaSintesiItinerario
                  :markers="markers"
                  :drinkingWaterPoints="drinkingWaterPoints"
                  :showDrinkingWater="showDrinkingWater"
                  :desktop="true"
                  :selectedLunchPoint="selectedLunchPoint"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ModalSintesiItinerario
      :modals="modals"
      :visualUnassigned="visualUnassigned"
      @bookItinerary="bookItinerary"
    />

    <ScrollTopArrow :createItinerary="false"></ScrollTopArrow>
  </div>
</template>
<script>
import store from "../store";
import $ from "jquery";
import { Button } from "element-ui";
import router from "../router";
import esperimento from "../components/customComponents/esperimento";
import visita from "../components/customComponents/visita";
import { isMobile } from "mobile-device-detect";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import Vue from "vue";
import { Radio, Modal, Switch } from "../components";
import { config } from "../utils/config";
import ScrollTopArrow from "../components/customComponents/ScrollTopArrow";
import MappaSintesiItinerario from "../components/customComponents/tesi/MappaSintesiItinerario.vue";
import ModalSintesiItinerario from "../components/customComponents/tesi/ModalSintesiItinerario.vue";
import ElencoPoiSmTesi from "../components/customComponents/tesi/ElencoPoiSmTesi.vue";
import ElencoPoiMdLgTesi from "../components/customComponents/tesi/ElencoPoiMdLgTesi.vue";

Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true,
});

const Common = require("@/Common.vue").default;

export default {
  name: "sintesiitinerariotesi",
  bodyClass: "strumenti-esperimenti-page",
  components: {
    Button,
    esperimento,
    visita,
    [Radio.name]: Radio,
    ScrollTopArrow,
    [Switch.name]: Switch,
    MappaSintesiItinerario,
    ModalSintesiItinerario,
    ElencoPoiSmTesi,
    ElencoPoiMdLgTesi,
  },
  data() {
    return {
      markers: [],
      markersPolylines: [],
      showDetails: false,
      selectedTab: "ElencoAttività",
      selectedArea: 0,
      allLoaded: false,
      itineraryCode: null,
      totalTimeObject: {},
      totalTimeSelectedArea: {},
      itinerario: null,
      isMobile: false,
      travellingTime: [],
      windowWidth: 0,
      unassigned: [],
      visualUnassigned: [],

      modals: {
        errorSavingItinerary: false,
        errorUnassignedPresent: false,
        askQuestionModal: false,
        errorSavingValutation: false,
        thanksForValutation: false,
      },

      timeFromParkingToFirstPOI: 0,

      amenities: [
        { tag: "drinking_water", label: "Fontanella" },
        { tag: "water_point", label: "Fontanella" },
      ],

      drinkingWaterPoints: [],
      showDrinkingWater: true,

      selectedLunchPoint: null,
    };
  },

  beforeCreate() {
    if (!config.isGeodidalab) {
      router.replace({
        name: "index",
      });
    }
  },

  mounted() {
    this.windowWidth = $(window).width();

    $(window).resize(() => {
      this.windowWidth = $(window).width();
    });

    this.isMobile = isMobile;

    var itinerarioVROOM = JSON.parse(sessionStorage.getItem("itinerarioVROOM")); //contiene i vari sottoitinerari
    store.state.sottoitinerari = itinerarioVROOM;

    console.log("itinerarioVROOM");
    console.log(itinerarioVROOM);

    console.log(this.$store.state.sottoitinerari[this.selectedArea]);

    Array.prototype.forEach.call(
      store.state.sottoitinerari,
      (itinerario, index) => {
        var startPoint = store.state.selectedStartPointForEachArea[index][0];
        var activitiesInPOI = [];

        var activity = {
          activityType: "Parcheggio al punto di partenza",
          activityName: 'Partenza da "' + startPoint.POItitle + '"',
          arrival: 0,
          description: 'Partenza da "' + startPoint.POItitle + '"',
          duration: 0,
          id: 1,
          index: 0,
          job: 1,
          location: [
            startPoint.marker["_latlng"].lng,
            startPoint.marker["_latlng"].lat,
          ],
          poiName: startPoint.POItitle,
          service: 0,
          serviceDurationMinutes: 0,
          setup: 0,
          type: "job",
          violations: [],
          waiting_time: 0,
        };

        activitiesInPOI.push(activity);

        var startPointObjectToAdd = {
          poiID: null,
          poiName: startPoint.POItitle,
          poiDescription: "Punto di partenza",
          location: [
            startPoint.marker["_latlng"].lng,
            startPoint.marker["_latlng"].lat,
          ],
          media: [],
          activitiesInPOI: activitiesInPOI,
        };

        var imageSrc = "";

        if (startPoint.type === "station") {
          imageSrc = "railwayImage";
        } else if (startPoint.type === "taxi") {
          imageSrc = "taxiImage";
        } else if (startPoint.type === "hospital") {
          imageSrc = "hospitalImage";
        } else if (startPoint.type === "parking") {
          imageSrc = "parkingImage";
        } else if (startPoint.type === "library") {
          imageSrc = "libraryImage";
        } else if (startPoint.type === "bar") {
          imageSrc = "barImage";
        }

        startPointObjectToAdd.media.push({
          src: imageSrc,
        });

        itinerario.poi.splice(1, 0, startPointObjectToAdd);
      }
    );

    //aggiungo il pranzo qua
    var positionIndexForLunch = store.getters.getPositionIndexForLunch;

    console.log("positionIndexForLunch");
    console.log(positionIndexForLunch);

    if (positionIndexForLunch !== null) {
      this.selectedLunchPoint = store.getters.getSelectedLunchPoint[0];
      var selectedLunchPoint = store.getters.getSelectedLunchPoint[0];

      var activitiesInPOILunch = [];
      //aggiungo il pranzo
      var lunch = {
        activityType: 'Pranzo a "' + selectedLunchPoint.POItitle + '"',
        activityName: 'Pranzo a "' + selectedLunchPoint.POItitle + '"',
        arrival: 0,
        description: 'Pranzo a "' + selectedLunchPoint.POItitle + '"',
        duration: 0,
        id: 1,
        index: 0,
        job: 1,
        location: [
          selectedLunchPoint.marker["_latlng"].lng,
          selectedLunchPoint.marker["_latlng"].lat,
        ],
        poiName: selectedLunchPoint.POItitle,
        service: 3600000,
        serviceDurationMinutes: 60,
        setup: 0,
        type: "job",
        violations: [],
        waiting_time: 0,
      };

      store.state.sottoitinerari[
        positionIndexForLunch.indexSottoitinerario
      ].totalTimeMilliseconds += 3600000; //aggiungo l'ora per il pranzo
      var sottoitinerari = store.state.sottoitinerari;

      if (positionIndexForLunch.indexActivity !== 0) {
        console.log("SONO NELL'IF");
        // aggiungo uno perchè prima ho inserito il punto di partenza

        var length =
          sottoitinerari[positionIndexForLunch.indexSottoitinerario].poi[
            positionIndexForLunch.indexPoi + 1
          ].activitiesInPOI.length;

        console.log("IN QUESTO POI HO N ATTIVITA");
        console.log(length);

        var firstActivities = sottoitinerari[
          positionIndexForLunch.indexSottoitinerario
        ].poi[positionIndexForLunch.indexPoi + 1].activitiesInPOI.slice(
          0,
          positionIndexForLunch.indexActivity
        );

        console.log("firstActivities");
        console.log(firstActivities);

        var remainingActivities = sottoitinerari[
          positionIndexForLunch.indexSottoitinerario
        ].poi[positionIndexForLunch.indexPoi + 1].activitiesInPOI.slice(
          positionIndexForLunch.indexActivity,
          length
        );

        console.log(
          sottoitinerari[positionIndexForLunch.indexSottoitinerario].poi[
            positionIndexForLunch.indexPoi + 1
          ]
        );

        console.log("DOPO IL PRANZO NE RIMARRANNO");
        console.log(remainingActivities);

        if (
          remainingActivities.length > 1 ||
          (remainingActivities.length === 1 &&
            remainingActivities[0].serviceDurationMinutes +
              remainingActivities[0].setupTimeMinutes >
              30)
        ) {
          // se le attività da fare dopo il pranzo sono più di una, inserisco il pranzo nel mezzo

          var poi =
            sottoitinerari[positionIndexForLunch.indexSottoitinerario].poi[
              positionIndexForLunch.indexPoi + 1
            ];

          var copyOfPOI = JSON.parse(
            JSON.stringify(
              sottoitinerari[positionIndexForLunch.indexSottoitinerario].poi[
                positionIndexForLunch.indexPoi + 1
              ]
            )
          );

          console.log("COPY OF POI");
          console.log(copyOfPOI);

          // Mettere a questo POI solo le prime N attività
          poi.activitiesInPOI = JSON.parse(JSON.stringify(firstActivities));

          copyOfPOI.activitiesInPOI = JSON.parse(
            JSON.stringify(remainingActivities)
          );

          console.log("COPY OF POI DOPO AVER CAMBIATO LE ATTIVITA'");
          console.log(copyOfPOI);
          // AGGIUNGO IL POI DEL PRANZO

          activitiesInPOILunch.push(lunch);

          var lunchPointObjectToAdd = {
            poiID: null,
            poiName: selectedLunchPoint.POItitle,
            poiDescription: "Punto per il pranzo",
            location: [
              selectedLunchPoint.marker["_latlng"].lng,
              selectedLunchPoint.marker["_latlng"].lat,
            ],
            media: [
              {
                src: this.getCorrectImage(selectedLunchPoint),
              },
            ],
            activitiesInPOI: activitiesInPOILunch,
          };

          var l =
            sottoitinerari[positionIndexForLunch.indexSottoitinerario].poi
              .length - 1;

          sottoitinerari[positionIndexForLunch.indexSottoitinerario].poi.splice(
            l,
            0,
            lunchPointObjectToAdd
          );

          this.getTimeFromLunchPoint(sottoitinerari, positionIndexForLunch);

          l =
            sottoitinerari[positionIndexForLunch.indexSottoitinerario].poi
              .length - 1;

          sottoitinerari[positionIndexForLunch.indexSottoitinerario].poi.splice(
            l,
            0,
            copyOfPOI
          );
        } else {
          activitiesInPOILunch.push(lunch);

          var lunchPointObjectToAdd = {
            poiID: null,
            poiName: selectedLunchPoint.POItitle,
            poiDescription: "Punto per il pranzo",
            location: [
              selectedLunchPoint.marker["_latlng"].lng,
              selectedLunchPoint.marker["_latlng"].lat,
            ],
            media: [
              {
                src: this.getCorrectImage(selectedLunchPoint),
              },
            ],
            activitiesInPOI: activitiesInPOILunch,
          };

          var l =
            sottoitinerari[positionIndexForLunch.indexSottoitinerario].poi
              .length - 1;

          sottoitinerari[positionIndexForLunch.indexSottoitinerario].poi.splice(
            l,
            0,
            lunchPointObjectToAdd
          );

          this.getTimeFromLunchPoint(sottoitinerari, positionIndexForLunch);
        }

        //TODO: dal poi devo rimuovere le attività che vanno dopo il pranzo e aggiungerle al poi successivo dopo il pranzo
        //TODO: nel mezzo devo aggiungere un nuovo poi con solo il pranzo
      } else {
        console.log("SONO NELL'ELSE");
        activitiesInPOILunch.push(lunch);

        var lunchPointObjectToAdd = {
          poiID: null,
          poiName: selectedLunchPoint.POItitle,
          poiDescription: "Punto per il pranzo",
          location: [
            selectedLunchPoint.marker["_latlng"].lng,
            selectedLunchPoint.marker["_latlng"].lat,
          ],
          media: [
            {
              src: this.getCorrectImage(selectedLunchPoint),
            },
          ],
          activitiesInPOI: activitiesInPOILunch,
        };

        console.log("POI PRIMA");
        console.log(
          sottoitinerari[positionIndexForLunch.indexSottoitinerario].poi
        );

        sottoitinerari[positionIndexForLunch.indexSottoitinerario].poi.splice(
          positionIndexForLunch.indexPoi + 1,
          0,
          lunchPointObjectToAdd
        ); // aggiungo uno perchè prima ho aggiunto il poi della partenza e di base c'è quello iniziale nell'oggetto

        console.log("POI DOPO");
        console.log(
          sottoitinerari[positionIndexForLunch.indexSottoitinerario].poi
        );

        this.getTimeFromLunchPoint(sottoitinerari, positionIndexForLunch);
      }
    }

    if (
      store.state.sottoitinerari !== undefined &&
      store.state.sottoitinerari !== null &&
      store.state.sottoitinerari.length > 0
    ) {
      Array.prototype.forEach.call(
        store.state.sottoitinerari,
        (sottoitinerario) => {
          if (sottoitinerario.unassignedArray.length > 0) {
            this.unassigned.push(sottoitinerario.unassignedArray);
          }

          //inoltre imposto la parte della giornata a quella di default se non è presente
          if (
            sottoitinerario.preferredPartOfDay === null ||
            sottoitinerario.preferredPartOfDay === undefined
          ) {
            sottoitinerario.preferredPartOfDay =
              config.omekaIDs.defaultPreferredPartOfDay;
          }
        }
      );

      this.unassigned = [].concat.apply([], this.unassigned);

      Array.prototype.forEach.call(this.unassigned, (unassigned) => {
        var splittedDescription = unassigned.description.split("_");
        var obj = {
          areaName: splittedDescription[0],
          activityName: splittedDescription[1],
          durata: unassigned.service / 60000,
        };

        this.visualUnassigned.push(obj);
      });

      if (this.unassigned.length > 0) {
        this.modals.errorUnassignedPresent = true;
      }

      this.setTravellingTime();

      this.getDescriptionAndMediaOfPOI();

      this.totalTimeObject = this.msToTime(this.totalTime);

      this.itinerario = store.state.sottoitinerari[0];

      this.totalTimeSelectedArea = this.msToTime(
        this.itinerario.totalTimeMilliseconds
      );

      this.getTimeFromParkingToFirstPOI();

      this.createMarkerArray();
      this.initializeMarkersOfFilteredPOI();

      var itineraryAlreadyExist = this.$route.params.itineraryAlreadyExist;

      if (!itineraryAlreadyExist) {
        //se la pagina  è ricaricata l'itinerario non deve essere ricaricato!!

        /*
        if (performance.navigation.type == performance.navigation.TYPE_RELOAD) {
          console.info("This page is reloaded");
          this.itineraryCode = store.state.itineraryCode;
        } else {
          console.info("This page is not reloaded");
          this.saveItinerary();
        }
        */

        this.saveItinerary(itinerarioVROOM);
      } else {
        this.itineraryCode = this.$route.params.itineraryCode;
      }

      this.allLoaded = true;
      var path = this.$store.state.sottoitinerari.map((item) =>
        item.name.replace("Itinerario_", "")
      );
    } else {
      //se l'utente carica l'url per la sinstesi dell'itinerario senza aver messo il codice viene mandato alla pagina dei percorsi
      router.push({ path: "/percorsi", replace: true });
    }
  },

  created() {},

  methods: {
    initFunction() {
      console.log("SONO NELLA INIT FUNCTION");
      this.numberOfActivityImagesRequest = 0;
      this.currentActivityImagesRequest = 0;

      var numberOfActivityImagesRequest = 0;

      Array.prototype.forEach.call(
        this.itinerario.poi.slice(1, this.itinerario.poi.length - 1),
        (poi) => {
          Array.prototype.forEach.call(poi.activitiesInPOI, (activity) => {
            if (!activity.activityName.includes("Visita")) {
              numberOfActivityImagesRequest++;
            }
          });
        }
      );

      this.numberOfActivityImagesRequest = numberOfActivityImagesRequest;

      Array.prototype.forEach.call(
        this.itinerario.poi.slice(1, this.itinerario.poi.length - 1),
        (poi) => {
          Array.prototype.forEach.call(poi.activitiesInPOI, (activity) => {
            if (!activity.activityName.includes("Visita")) {
              var url =
                "https://dev.geodidalab.unito.it/api/items?fulltext_search=&property[0][joiner]=and&property[0][property]=&property[0][type]=eq&property[0][text]=" +
                activity.activityName.replace(/ /g, "+") +
                "&resource_class_id[]=130&resource_template_id[]=&item_set_id[]=&site_id=&owner_id=&submit=Search";

              console.log("URL");
              console.log(url);

              this.$http.get(url).then(
                (response) => {
                  var activities = JSON.parse(response.bodyText);
                  console.log("ACTIVITIES");
                  console.log(activities);

                  if (activities.length > 0) {
                    console.log("CHIEDO MEDIA");
                    Common.getElementImages(
                      this,
                      activities[0],
                      (mediaList) => {
                        activity.media = mediaList;

                        console.log("ACTIVITY MEDIA");
                        console.log(activity.media);
                        this.currentActivityImagesRequest++;
                      }
                    );
                  }
                },
                (response) => {
                  //ERRORE
                }
              );
            }
          });
        }
      );
    },

    // Convert a time in hh:mm format to minutes
    timeToMins(time) {
      var b = time.split(":");
      return b[0] * 60 + +b[1];
    },

    // Convert minutes to a time in format hh:mm
    // Returned value is in range 00  to 24 hrs
    timeFromMins(mins) {
      function z(n) {
        return (n < 10 ? "0" : "") + n;
      }
      var h = ((mins / 60) | 0) % 24;
      var m = mins % 60;
      return z(h) + ":" + z(m);
    },

    // Add two times in hh:mm format
    addTimes(t0, t1) {
      return this.timeFromMins(this.timeToMins(t0) + this.timeToMins(t1));
    },
    getSrc(poi) {
      var img = null;

      if (poi.media.length > 0) {
        if (poi.media[0].src === undefined) {
          //do nothing
        } else {
          var contextImages = null;
          var pathStr = "";

          if (!this.isLarge) {
            contextImages = require.context("../icons/large/", false, /\.png$/);
            pathStr = "./" + poi.media[0].src + "Large.png";
          } else {
            contextImages = require.context(
              "../icons/startPointImages/",
              false,
              /\.svg$/
            );
            pathStr = "./" + poi.media[0].src + ".svg";
          }

          img = contextImages(pathStr);
        }
        return poi.media[0].src === undefined
          ? poi.media[0]["thumbnail_display_urls"]["large"]
          : img;
      } else {
        return null;
      }
    },

    getCorrectImage(selectedLunchPoint) {
      if (selectedLunchPoint.type === "restaurant") {
        return "restaurantImage";
      } else if (
        selectedLunchPoint.type === "bar" ||
        selectedLunchPoint.type === "cafe"
      ) {
        return "barImage";
      } else if (selectedLunchPoint.type === "picnic_site") {
        return "picnicSiteImage";
      } else if (selectedLunchPoint.type === "pub") {
        return "pubImage";
      } else if (selectedLunchPoint.type === "fast_food") {
        return "fastfoodImage";
      }
    },
    goBack() {
      router.go(-1);
    },

    getGroupName(poi) {
      return poi.poiName.replaceAll('"', "");
    },

    getGroupNameMarker(marker) {
      return marker.POItitle.replaceAll('"', "");
    },

    getDescriptionAndMediaOfPOI() {
      Array.prototype.forEach.call(
        store.state.sottoitinerari,
        (sottoitinerario) => {
          Array.prototype.forEach.call(sottoitinerario.poi, (poi) => {
            var filteredPOI = store.state.POIpivot.filter(
              (p) => p["geo:Titolo_it"][0]["@value"] === poi.poiName
            );

            //se non vale questa condizione allora si tratta del Punto di Partenza o del Punto di Arrivo e quindi non sono presenti nei POi pivot
            if (filteredPOI.length > 0) {
              poi.poiDescription = filteredPOI[0]["dcterms:description"]
                ? filteredPOI[0]["dcterms:description"][0]["@value"]
                : "Nessuna descrizione disponibile";
              poi.media = filteredPOI[0]["media"];
              poi.poiID = filteredPOI[0]["o:id"];
            }
          });
        }
      );
    },

    getCount(i, j) {
      var k = 0;
      var l = 0;
      for (var x = 1; x <= i; x++) {
        for (
          var h = 0;
          h < this.itinerario.poi[x].activitiesInPOI.length;
          h++
        ) {
          if (x === i) {
            if (l < j) {
              l += 1;
            }
          } else {
            k += 1;
          }
        }
      }

      k += l;

      return k + 1;
    },

    selectMarkerOnMap(poiName, activityName) {
      this.showDetails = true;

      var markerLocation = null;
      Array.prototype.forEach.call(this.markers, (marker) => {
        if (marker.POItitle === poiName) {
          marker.poiSelected = true;
          markerLocation = marker;
        } else {
          marker.poiSelected = false;
        }
      });

      this.showInfoAtivity(poiName, activityName);

      this.getDrinkingWaterPoints(markerLocation.marker["_latlng"]);
    },

    showInfoAtivity(poiName, activityName) {
      var selectedPOI = null;
      Array.prototype.forEach.call(store.state.POIpivot, (poi) => {
        if (poiName === poi["geo:Titolo_it"][0]["@value"]) {
          selectedPOI = poi;

          //il component per la visualizzazione delle visite usa mediaImages
          if (selectedPOI.mediaImages === undefined) {
            selectedPOI.mediaImages = selectedPOI.media;
          }
        }
      });

      if (!activityName.includes("Visita")) {
        this.activityVisitPOISelectedForInfo = null;

        Array.prototype.forEach.call(store.state.esperimenti, (activity) => {
          if (activity["o:title"] === activityName) {
            this.activitySelectedForInfo = activity;
          }
        });

        this.activityVisitPOISelectedForInfo = null;
      } else {
        this.activityVisitPOISelectedForInfo = selectedPOI;

        this.activitySelectedForInfo = null;
      }
    },

    showItinerary() {
      this.showDetails = false;
      this.drinkingWaterPoints = [];
    },

    selectItinerario(index) {
      this.goBackAndResetMarkersIcon();

      this.itinerario = store.state.sottoitinerari[index];
      this.totalTimeSelectedArea = this.msToTime(
        this.itinerario.totalTimeMilliseconds
      );

      this.selectedArea = index;

      this.createMarkerArray();
      this.initializeMarkersOfFilteredPOI();

      //TODO: get time from parking to first poi

      this.getTimeFromParkingToFirstPOI();
    },

    getDrinkingWaterPoints(pointLocation) {
      var query = "[out:json];(";
      Array.prototype.forEach.call(this.amenities, (amenity, index) => {
        var string =
          "node[amenity=" +
          amenity.tag +
          "](around: 200, " +
          pointLocation.lat +
          "," +
          pointLocation.lng +
          ");way[amenity=" +
          amenity.tag +
          "](around: 200, " +
          pointLocation.lat +
          "," +
          pointLocation.lng +
          ");relation[amenity=" +
          amenity.tag +
          "](around: 200, " +
          pointLocation.lat +
          "," +
          pointLocation.lng +
          ");";
        query += string;
      });

      query += ");out center;";

      (async () => {
        const api = await fetch(
          "https://www.overpass-api.de/api/interpreter?",
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: query,
          } //node(dal centro in basso, dal centro a sinistra, dal centro in alto, dal centro a destra)
        ).catch((error) => {
          // Your error is here!
          console.log("ERRORE");
          console.log(error);
        });
        const answer = await api.json();

        var startPoints = [];

        Array.prototype.forEach.call(answer.elements, (elem, index) => {
          if (elem.type === "node") {
            this.addNodeElemToCorrectArray(
              elem,
              index,
              "Fontanella ",
              "drinking_water",
              startPoints
            );
          } else {
            this.addWayElemToCorrectArray(
              elem,
              index,
              "Fontanella ",
              "drinking_water",
              startPoints
            );
          }
        });

        this.drinkingWaterPoints = startPoints;
      })().catch((error) => {
        // Your error is here!
        console.log("ERRORE");
        console.log(error);
      });
    },
    addNodeElemToCorrectArray(elem, index, stringName, stringType, array) {
      var pointsLatLng = array.filter(function (point) {
        return (
          point.marker.getLatLng().lat.toFixed(3) === elem.lat.toFixed(3) &&
          point.marker.getLatLng().lng.toFixed(3) === elem.lon.toFixed(3)
        );
      });

      if (elem.tags.name) {
        var points = array.filter(function (point) {
          return point.POItitle === stringName + elem.tags.name;
        });

        if (points.length === 0 && pointsLatLng.length === 0) {
          array.push({
            marker: L.marker([elem.lat, elem.lon]),
            color: "#1585bd",
            strokeColor: "#1b4f88",
            circleColor: "#ffffff",
            POItitle: elem.tags.name
              ? stringName + elem.tags.name
              : stringName + index,
            poiSelected: false,
            image: undefined,
            type: stringType,
          });
        }
      } else {
        if (pointsLatLng.length === 0) {
          array.push({
            marker: L.marker([elem.lat, elem.lon]),
            color: "#1585bd",
            strokeColor: "#1b4f88",
            circleColor: "#ffffff",
            POItitle: elem.tags.name
              ? stringName + elem.tags.name
              : stringName + index,
            poiSelected: false,
            image: undefined,
            type: stringType,
          });
        }
      }
    },
    addWayElemToCorrectArray(elem, index, stringName, stringType, array) {
      var pointsLatLng = array.filter(function (point) {
        return (
          point.marker.getLatLng().lat.toFixed(3) ===
            elem.center.lat.toFixed(3) &&
          point.marker.getLatLng().lng.toFixed(3) === elem.center.lon.toFixed(3)
        );
      });

      if (elem.tags.name) {
        var points = array.filter(function (point) {
          return point.POItitle === stringName + elem.tags.name;
        });

        if (points.length === 0 && pointsLatLng.length === 0) {
          array.push({
            marker: L.marker([elem.center.lat, elem.center.lon]),
            color: "#1585bd",
            strokeColor: "#1b4f88",
            circleColor: "#ffffff",
            POItitle: elem.tags.name
              ? stringName + elem.tags.name
              : stringName + index,
            poiSelected: false,
            image: undefined,
            type: stringType,
          });
        }
      } else {
        if (pointsLatLng.length === 0) {
          array.push({
            marker: L.marker([elem.center.lat, elem.center.lon]),
            color: "#1585bd",
            strokeColor: "#1b4f88",
            circleColor: "#ffffff",
            POItitle: elem.tags.name
              ? stringName + elem.tags.name
              : stringName + index,
            poiSelected: false,
            image: undefined,
            type: stringType,
          });
        }
      }
    },
    getTimeFromLunchPoint(sottoitinerari, positionIndexForLunch) {
      var self = this;
      var poiBeforeLunch =
        sottoitinerari[positionIndexForLunch.indexSottoitinerario].poi[
          positionIndexForLunch.indexPoi - 1
        ];

      var poiOfLunch =
        sottoitinerari[positionIndexForLunch.indexSottoitinerario].poi[
          positionIndexForLunch.indexPoi
        ];

      var poiAfterLunch =
        sottoitinerari[positionIndexForLunch.indexSottoitinerario].poi[
          positionIndexForLunch.indexPoi + 1
        ];

      var url =
        "https://router.project-osrm.org/route/v1/driving/" +
        poiBeforeLunch.location[0] +
        "," +
        poiBeforeLunch.location[1] +
        ";" +
        poiOfLunch.location[0] +
        "," +
        poiOfLunch.location[1];

      var self = this;
      $.ajax({
        url: url,
        type: "GET",
        contentType: "application/json",
        data: null,
        success: function (result) {
          var time1 =
            self.totalTimeObject.hours + ":" + self.totalTimeObject.minutes;
          var time2 = new Date(Math.round(result.routes[0].duration * 7) * 1000)
            .toISOString()
            .slice(11, 16);

          var newTime = self.addTimes(time1, time2).split(":");

          self.totalTimeObject.hours = newTime[0];
          self.totalTimeObject.minutes = newTime[1];

          store.commit("setTravellingTimeFromPoiBeforeLunchToLunch", {
            travellingTimeFromPoiBeforeLunchToLunch:
              Math.round(result.routes[0].duration * 7) * 1000,
          });

          var url =
            "https://router.project-osrm.org/route/v1/driving/" +
            poiOfLunch.location[0] +
            "," +
            poiOfLunch.location[1] +
            ";" +
            poiAfterLunch.location[0] +
            "," +
            poiAfterLunch.location[1];

          $.ajax({
            url: url,
            type: "GET",
            contentType: "application/json",
            data: null,
            success: function (result) {
              var time1 =
                self.totalTimeObject.hours + ":" + self.totalTimeObject.minutes;
              var time2 = new Date(
                Math.round(result.routes[0].duration * 7) * 1000
              )
                .toISOString()
                .slice(11, 16);

              var newTime = self.addTimes(time1, time2).split(":");

              self.totalTimeObject.hours = newTime[0];
              self.totalTimeObject.minutes = newTime[1];

              store.commit("setTravellingTimeFromLunchToPoiAfterLunch", {
                travellingTimeFromLunchToPoiAfterLunch:
                  Math.round(result.routes[0].duration * 7) * 1000,
              });
            },
            error: function (error) {
              console.log("ERRORE");
              console.log(error);
            },
          });
        },
        error: function (error) {
          console.log("ERRORE");
          console.log(error);
        },
      });
    },
    getTimeFromParkingToFirstPOI() {
      var url =
        "https://router.project-osrm.org/route/v1/driving/" +
        this.itinerario.poi[1].location[0] +
        "," +
        this.itinerario.poi[1].location[1] +
        ";" +
        this.itinerario.poi[2].location[0] +
        "," +
        this.itinerario.poi[2].location[1];

      var self = this;
      $.ajax({
        url: url,
        type: "GET",
        contentType: "application/json",
        data: null,
        success: function (result) {
          self.timeFromParkingToFirstPOI = Math.floor(
            (result.routes[0].duration * 7) / 60
          );
        },
        error: function (error) {
          console.log("ERRORE");
          console.log(error);
        },
      });
    },
    goBackAndResetMarkersIcon() {
      this.showDetails = false;
      Array.prototype.forEach.call(this.markers, (marker) => {
        marker.poiSelected = false;
      });

      this.drinkingWaterPoints = [];
    },
    copyItineraryCode() {
      // navigator clipboard api needs a secure context (https)
      if (navigator.clipboard && window.isSecureContext) {
        // navigator clipboard api method'
        navigator.clipboard.writeText(String(this.itineraryCode));
      } else {
        // text area method
        let textArea = document.createElement("textarea");
        textArea.value = String(this.itineraryCode);
        // make the textarea out of viewport
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        new Promise((res, rej) => {
          // here the magic happens
          document.execCommand("copy") ? res() : rej();
          textArea.remove();
        });
      }

      this.$toast("Codice itinerario copiato negli appunti!", {
        position: "top-right",
        timeout: 5000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: "button",
        icon: true,
        rtl: false,
      });
    },
    bookItinerary(questions) {
      var self = this;

      console.log("DOMANDE");
      console.log(questions);

      var errorIsPresent = false;

      // stampo le risposte inserite per la valutazione
      Array.prototype.forEach.call(questions, (question) => {
        if (question.selectedResponse === "") {
          question.responseError = true;
          errorIsPresent = true;
        }
      });

      if (!errorIsPresent) {
        this.modals.askQuestionModal = false;

        this.saveValutationOnDB(questions);

        // apro il client mail
        this.sendEmail();
      }
    },
    saveValutationOnDB(questions) {
      //TODO: IMPLEMENTARE SALVATAGGIO RISPOSTE SUL DB

      /*
      Tabella con i seguenti campi: ID (automatico), codice itinerario, domanda, risposta, FORSE HA SENSO IL CAMPO "itinerario creato / predefinitio"
      */

      var strToSend = "";

      Array.prototype.forEach.call(questions, (question) => {
        strToSend +=
          this.itineraryCode +
          ";" +
          question.question +
          ";" +
          question.selectedResponse +
          ";" +
          true.toString() +
          "\n";
      });

      var self = this;

      $.ajax({
        url: "/geodidalab/api/itinerari/valutazioni",
        type: "POST",
        contentType: "application/json",
        data: strToSend,
        success: function (result) {
          self.modals.thanksForValutation = true;
        },
        error: function (error) {
          self.modals.errorSavingValutation = true;
        },
      });
    },

    saveItinerary(itinerarioVROOM) {
      var self = this;

      $.ajax({
        url: "/geodidalab/api/itinerari/",
        type: "POST",
        dataType: "json",
        contentType: "application/json",
        data: JSON.stringify(itinerarioVROOM),
        success: function (result) {
          self.itineraryCode = result;
          store.state.itineraryCode = result;
        },
        error: function (error) {
          self.modals.errorSavingItinerary = true;
        },
      });
    },

    createMarkerArray() {
      //Punto di partenza
      //this.markersPolylines.push(this.startPoint);
      Array.prototype.forEach.call(this.itinerario.poi, (poi) => {
        if (poi["location"]) {
          var POIlat = poi["location"][0];
          var POIlng = poi["location"][1];

          var POIcoordinates = [POIlat, POIlng];

          this.markersPolylines.push(POIcoordinates);
        }
      });

      //Punto di arrivo
      //this.markersPolylines.push(this.endPoint);
    },

    initializeMarkersOfFilteredPOI() {
      this.markers = [];

      Array.prototype.forEach.call(this.itinerario.poi, (poi) => {
        //viene usato anche per il punto di arrivo
        var isStartingPoint =
          poi["poiName"] === "Punto di partenza" ||
          poi["poiName"] === "Punto di arrivo";

        if (isStartingPoint) {
          //do nothing
        } else {
          if (poi["location"]) {
            this.markers.push({
              marker: L.marker([poi["location"][1], poi["location"][0]]),
              color: "#1585bd",
              strokeColor: "#1b4f88",
              circleColor: "#ffffff",
              POItitle: poi["poiName"],
              POIdescription: poi["poiDescription"],
              image: this.getSrc(poi),
              links: poi['geo:Scheda_esterna'],
              //TODo: aggiungere attributi
              isStartPoint: isStartingPoint,
              poiSelected: false,
            });
          }
        }
      });

      this.markersCreated = true;
    },

    askQuestion() {
      this.modals.askQuestionModal = true;
    },

    sendEmail() {
      var emailAddress = "info@geodidalab.it";
      var subject = "Richiesta informazioni itineraio " + this.itineraryCode;
      var preferredPartOfDay =
        this.$store.state.preferredPartOfDay === "mattina"
          ? "mattino"
          : this.$store.state.preferredPartOfDay;

      var body =
        "Gentile GeoDidaLab,%0D%0A siamo interessati alla realizzazione dell'itinerario nell'oggetto, da svolgersi preferibilmente al " +
        preferredPartOfDay +
        '.%0D%0A Attendiamo un gentile riscontro. %0D%0A %0D%0A ------------------------------------------------ %0D%0A %0D%0A Per rivedere in futuro l\'itinerario creato è necessario collegarsi al link https://openalplab.unito.it/geodidalab#/percorsi, andare nella sezione "Inserisci il codice del tuo itinerario" e inserire il codice ' +
        this.itineraryCode +
        ".";

      var mail = document.createElement("a");
      mail.href =
        "mailto:" + emailAddress + "?subject=" + subject + "&body=" + body;
      mail.click();
    },

    msToTime(duration) {
      var milliseconds = Math.floor((duration % 1000) / 100),
        seconds = Math.floor((duration / 1000) % 60),
        minutes = Math.floor((duration / (1000 * 60)) % 60),
        hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      var timeObject = {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        milliseconds: milliseconds,
      };

      if (isNaN(duration)) {
        timeObject = {
          hours: null,
          minutes: null,
          seconds: null,
          milliseconds: null,
        };
      }

      return timeObject;
    },

    setTravellingTime() {
      var areas = [];

      //Recupero le aree a cui appartengono i sottoitinerari
      Array.prototype.forEach.call(
        this.$store.state.sottoitinerari,
        (sottoitinerario) => {
          var areaID = sottoitinerario.areaID;
          areas.push(areaID);
        }
      );

      //Sommo i tempi di tragitto da un'area all'altra

      for (var i = 0; i < this.$store.state.sottoitinerari.length - 1; i++) {
        var string = "";

        var distancesFromAreaOfIndexI =
          this.$store.state.costMatricesTimeBetweenAreas.filter(
            (area) =>
              parseInt(area.AreaID) ===
              this.$store.state.sottoitinerari[i].areaID
          );
        var distancesFromAreaOfIndexIPlus1 =
          this.$store.state.costMatricesTimeBetweenAreas.filter(
            (area) =>
              parseInt(area.AreaID) ===
              this.$store.state.sottoitinerari[i + 1].areaID
          );

        var destinationAreaString = String(
          this.$store.state.sottoitinerari[i + 1].areaID
        );

        var areaNameIndexI = distancesFromAreaOfIndexI[0]
          ? distancesFromAreaOfIndexI[0].AreaName
          : this.$store.state.sottoitinerari[i].areaName;
        var areaNameIndexIPlus1 = distancesFromAreaOfIndexIPlus1[0]
          ? distancesFromAreaOfIndexIPlus1[0].AreaName
          : this.$store.state.sottoitinerari[i + 1].areaName;
        var timeBetweenAreas =
          distancesFromAreaOfIndexI[0] &&
          distancesFromAreaOfIndexI[0][destinationAreaString]
            ? distancesFromAreaOfIndexI[0][destinationAreaString]
            : config.omekaIDs.defaultTravelTimeBetweenPOIs * 60000;

        string =
          "Tempo di spostamento in auto da " +
          areaNameIndexI +
          " a " +
          areaNameIndexIPlus1 +
          ": " +
          timeBetweenAreas / 60000 + // converto i millisecondi in minuti
          " minuti \n";

        this.travellingTime.push(string);
      }
    },

    checkPoiAndNextPoiAreDifferent(poi, nextPOI) {
      // se ho gli id uso quelli per capire se sono diversi, altrimenti (esempio poi pranzo (POI esterno a omeka) uso il nome
      return poi.poiID && nextPOI.poiID
        ? poi.poiID !== nextPOI.poiID
        : poi.poiName !== nextPOI.poiName;
    },

    getTimeToNextPOI(poi, nextPOI) {
      if (nextPOI.poiDescription.includes("pranzo")) {
        var time = store.getters.getTravellingTimeFromPoiBeforeLunchToLunch;
        var timeMinutes = Math.ceil(time / 60000);

        if (timeMinutes === 1 || timeMinutes === 0) {
          return "1 minuto";
        } else {
          return timeMinutes + " minuti";
        }
      } else if (poi.poiDescription.includes("pranzo")) {
        var time = store.getters.getTravellingTimeFromLunchToPoiAfterLunch;
        var timeMinutes = Math.ceil(time / 60000);

        if (timeMinutes === 1 || timeMinutes === 0) {
          return "1 minuto";
        } else {
          return timeMinutes + " minuti";
        }
      } else {
        var timesFromPOI = store.state.costMatricesTimeBetweenPOI.filter(
          (p) => parseInt(p["PoiID"]) === poi.poiID
        );

        var timeMillis = config.omekaIDs.defaultTravelTimeBetweenPOIs * 60000; //minuti di default di spostamento tra un poi e l'altro

        if (timesFromPOI[0]) {
          timeMillis = timesFromPOI[0][nextPOI.poiID];
        }

        if (timeMillis === "-1") {
          //se il tempo è -1 vuol dire che non è stato possibile calcolare il tempo di spostamento tra i due POI e usiamo quello di default
          timeMillis = config.omekaIDs.defaultTravelTimeBetweenPOIs * 60000;
        }

        var timeMinutes = timeMillis / 60000;

        if (timeMinutes === 1) {
          return timeMinutes + " minuto";
        } else {
          return timeMinutes + " minuti";
        }
      }
    },
  },

  computed: {
    isLarge() {
      return this.windowWidth >= 768;
    },
    timeIsZero() {
      return (
        (this.totalTimeObject.hours === "00" &&
          this.totalTimeObject.minutes === "00" &&
          this.totalTimeObject.seconds === "00" &&
          this.totalTimeObject.milliseconds === 0) ||
        (this.totalTimeObject.hours === null &&
          this.totalTimeObject.minutes === null &&
          this.totalTimeObject.seconds === null &&
          this.totalTimeObject.milliseconds === null)
      );
    },

    totalTime() {
      var areas = [];
      var time = 0;

      //Recupero le aree a cui appartengono i sottoitinerari
      Array.prototype.forEach.call(
        this.$store.state.sottoitinerari,
        (sottoitinerario) => {
          var areaID = sottoitinerario.areaID;
          areas.push(areaID);
        }
      );

      //Sommo i tempi relativi ai sottoitinerari
      Array.prototype.forEach.call(
        this.$store.state.sottoitinerari,
        (sottoitinerario) => {
          time += sottoitinerario.totalTimeMilliseconds;
        }
      );

      //Sommo i tempi di tragitto da un'area all'altra
      for (var i = 0; i < areas.length - 1; i++) {
        var distancesFromAreaOfIndexI =
          this.$store.state.costMatricesTimeBetweenAreas.filter(
            (area) => parseInt(area.AreaID) === areas[i]
          );
        var destinationAreaString = String(areas[i + 1]);

        if (
          distancesFromAreaOfIndexI.length === 0 ||
          distancesFromAreaOfIndexI[0][destinationAreaString] === undefined
        ) {
          //SOMMO I MINUTI DI DEFAULT DI SPOSTAMENTO TRA LE AREE
          time += config.omekaIDs.defaultTravelTimeBetweenAreas * 60000;
        } else {
          time += distancesFromAreaOfIndexI[0][destinationAreaString];
        }
      }

      return time;
    },
  },

  watch: {
    itinerario(newValue, oldValue) {
      this.initFunction();
    },
  },
};
</script>
<style>
</style>
